export interface CQCode {
	sku: string;
	description: string;
	productId: string;
}

export const CQ_CODES: CQCode[] = [
	{
		sku: "CQA",
		description: "CQ#- Custom Accessory Quote",
		productId: "1-CQA"
	},
	{
		sku: "CQB",
		description: "CQ#- Custom Base Cabinet",
		productId: "1-CQB"
	},
	{
		sku: "CQFP",
		description: "CQ#- Custom Quote Refrigerator Panel",
		productId: "1-CQFP"
	},
	{
		sku: "CQH",
		description: "CQ#- Custom Hood Quote",
		productId: "1-CQH"
	},
	{
		sku: "CQU",
		description: "CQ#- Custom Tall Cabinet Quote",
		productId: "1-CQU"
	},
	{
		sku: "CQU120",
		description: 'CQ#- Custom Tall Cabinet Over 96" Tall',
		productId: "1-CQU120"
	},
	{
		sku: "CQU120LT",
		description: 'CQ#- Custom Tall Cabinet Over 96" Tall W/Loose Toe',
		productId: "1-CQU120LT"
	},
	{
		sku: "CQULT",
		description: "CQ#- Custom Tall Cabinet W/ Loose Toe",
		productId: "1-CQULT"
	},
	{
		sku: "CQV",
		description: "CQ#- Custom Vanity Cabinet",
		productId: "1-CQV"
	},
	{
		sku: "CQW",
		description: "CQ#- Custom Wall Quote",
		productId: "1-CQW"
	},
	{
		sku: "BDCQ",
		description: "CQ#- Box Doors Custom Quote",
		productId: "1-BDCQ"
	},
	{
		sku: "CQS",
		description: "CQ#- Custom Accessory Quote",
		productId: "1-CQS"
	},
	{
		sku: "DACQ",
		description: "CQ#- Custom Drawerfront And Box",
		productId: "1-DACQ"
	}
] as const;
